import { capitalize } from "lodash";
import type { DenialQueryReasonBucket } from "../../../../../data-model/denialQueryBucket";

/** Props for the {@link Reasons} component. */
interface ReasonsProps {
  /** Heading displayed above the reason list. */
  heading: string;
  /** Color applied to the heading and numbered markers. */
  textColor: string;
  /** Number of grid columns used to display reasons. Defaults to two. */
  numberOfColumns?: number;
  /** Reason buckets displayed in the list. */
  reasons: DenialQueryReasonBucket[];
}

/**
 * Displays supplied regimen reason buckets and all-time counts in a configurable grid.
 *
 * @param props - Heading, accent color, reason buckets, and grid-column count.
 * @returns The reason-bucket list.
 */
const Reasons = ({
  heading,
  textColor,
  numberOfColumns = 2,
  reasons,
}: ReasonsProps) => {
  return (
    <>
      <div
        className="reason-header mb-[0.62rem] text-x-tiny font-bold"
        style={{ color: textColor }}
      >
        {heading}
      </div>
      <div
        className="reasons-list grid gap-1 text-x-tiny font-bold"
        style={{
          gridTemplateColumns: `repeat(${numberOfColumns}, minmax(0, 1fr))`,
        }}
      >
        {reasons.map((reason, index) => (
          <div
            key={reason.id ?? `${reason.reason_bucket ?? "reason"}-${index}`}
            className="reason-item flex w-full text-x-tiny font-normal"
          >
            <span
              className="mr-2 text-x-tiny font-bold"
              style={{ color: textColor }}
            >
              {index + 1}.
            </span>
            <span>
              {capitalize(reason?.reason_bucket ?? "NA")} (
              {reason?.total_count ?? 0})
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default Reasons;
